<template>
  <div>
    <template v-if="showSignup">
      <b-button
        @click="personaliseSignup"
        class="js-open-signup-popup w-full"
        :class="{ 'm:w-72': !fullWidth }"
        :data-login-path="loginPath"
        :data-signup-path="signupPath"
      >
        {{ createCta }}
      </b-button>
    </template>
    <template v-if="showLogin">
      <p class="mt-4 mb-0 text-center m:text-left">
        {{ $t("alreadyHaveAnAccount") }}
        <a
          @click="personaliseLogin"
          :href="loginPath"
          class="js-open-login-popup"
          :data-login-path="loginPath"
          :data-signup-path="signupPath"
        >
          {{ $t("login") }}
        </a>
      </p>
    </template>
    <template v-if="!showSignup && !showLogin">
      <form method="post" :action="inviteeName ? joinPath : null">
        <input type="hidden" name="authenticity_token" :value="authenticityToken" />
        <input type="hidden" name="inviter_name" :value="inviterName" />
        <input type="hidden" name="invitee_name" :value="inviteeName" />
        <b-button
          @click="!inviteeName ? goTo(joinPathAfterLoginOrSignup) : null"
          :disabled="disabled"
          :class="{ 'm:w-72': !fullWidth }"
          class="w-full"
          :type="inviteeName ? 'submit' : 'button'"
        >
          {{ $t("accept") }}
        </b-button>
      </form>

      <p v-if="showLogoutLink" class="mt-4 mb-0 text-center m:text-left">
        <a :href="logoutPath">{{ $t("notYourAccount") }}</a>
      </p>
    </template>
  </div>
</template>

<script>
import BButton from "@/component-library/b-button"
import globals from "@/utils/globals"
import { mapGetters } from "vuex"
import { go } from "@/utils/location"

export default {
  name: "ButtonsSection",
  components: {
    BButton
  },
  props: {
    showLogin: {
      default: false,
      type: Boolean
    },
    showSignup: {
      default: false,
      type: Boolean
    },
    showLogoutLink: {
      default: false,
      type: Boolean
    },
    inviteCode: {
      required: true,
      type: String
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    inviteeName: {
      type: String,
      default: ""
    },
    inviterName: {
      type: String,
      default: ""
    },
    personalise: {
      type: Boolean,
      default: false
    },
    signupHeadline: {
      type: String,
      default: ""
    },
    loginHeadline: {
      type: String,
      default: ""
    }
  },
  computed: {
    ...mapGetters(["authenticityToken"]),
    joinPath() {
      return `/${this.$i18n.locale}/nc/join/${this.inviteCode}`
    },
    connectPath() {
      return `/${this.$i18n.locale}/nc/connect/${this.inviteCode}`
    },
    joinPathAfterLoginOrSignup() {
      return `/${this.$i18n.locale}/nc/connect/${this.inviteCode}?fromLoginSignup=true`
    },
    signupPath() {
      return `${globals.routes.signup}?last_page_before_login=${encodeURIComponent(this.joinPathAfterLoginOrSignup)}`
    },
    loginPath() {
      return `${globals.routes.login}?last_page_before_login=${encodeURIComponent(this.joinPathAfterLoginOrSignup)}`
    },
    logoutPath() {
      return `${globals.routes.logout}?last_page_before_login=${encodeURIComponent(this.connectPath)}`
    },
    createCta() {
      return this.$t("createAccount", { inviterName: this.inviterName })
    }
  },
  methods: {
    goTo(url) {
      go(url)
    },
    personaliseSignup() {
      if (!this.personalise) return
      setTimeout(() => {
        const headline = document.querySelector(".auth-popup-form__headline")
        headline.innerHTML = this.signupHeadline
      }, 0)
    },
    personaliseLogin() {
      if (!this.personalise) return
      setTimeout(() => {
        const headline = document.querySelector(".auth-popup-form__headline")
        headline.innerHTML = this.loginHeadline
      }, 0)
    }
  },
  i18n: {
    messages: {
      en: {
        createAccount: "Join {inviterName}",
        alreadyHaveAnAccount: "Already have an account?",
        login: "Log in",
        notYourAccount: "This is not your account?",
        accept: "Explore Blinkist"
      },
      de: {
        createAccount: "Blinkist entdecken",
        alreadyHaveAnAccount: "Du hast schon ein Konto? Melde dich an",
        login: "einloggen",
        notYourAccount: "Nicht dein Account?",
        accept: "Blinkist entdecken"
      }
    }
  }
}
</script>
